<p-toast></p-toast>
<div class="card dropdown-content">
    <div class="p-fluid p-formgrid grid mt-3 justify-content-center">
        <div class="field col-12 md:col-6">
            <div class="grid-item">
                <button pButton pRipple label="{{ 'यदि आप सूक्ष्म सिंचाई प्रणाली (सब्सिडी आधारित) स्थापित करना चाहते हैं तो आवेदन जमा करने के लिए यहां क्लिक करें' | translate }}" (click)="onClickAvailSub()"
                    class="availSubButton justify-content-center" style="min-height: 10vh;"></button>
            </div>
        </div>

        <div class="field col-12 md:col-6">
            <div class="grid-item">
                <button pButton pRipple label="{{ 'यदि खेतों में सूक्ष्म सिंचाई प्रणाली पहले से ही स्थापित है तो मौजूदा एमआई विवरण दर्ज करने के लिए यहां क्लिक करें' | translate }}" (click)="onClickExtMI()"
                    class="extMIButton justify-content-center" style="min-height: 10vh;"></button>
            </div>
        </div>

        <!-- <div class="field col-12 md:col-4">
            <div class="grid-item">
            </div>
        </div> -->
    </div>
</div>

<div *ngIf="showOwnMIResourceCard" class="p-fluid p-formgrid justify-content-center" style="display: flex; flex-wrap:wrap">
    <div class="field md:col-6 col-12">
        <button pButton pRipple (click)="downloadNOC()" label="{{'Download NOC' | translate}}" class="p-button-success"></button>
    <!-- style="width: 100px; height: 100px; align-items: center;"> -->
        <!-- <label>{{'APP_ID'| translate}}: <label [style]="{color: 'rgb(168, 32, 32)'}">{{
                applicationNo}}</label></label> -->
    </div>

</div>

<div *ngIf="showOwnMIResourceCard">
    <div class="own-mi-farmer-details card" #targetTable>
        <form [formGroup]="ownMIfarmerDetailsForm" (ngSubmit)="onSubmitfarmerOwnMIDetails()">
            <p [style]="{'color': 'rgb(168, 32, 32)', 'font-weight': 'bold', 'font-size': '1.0rem'}">{{ 'Own MI Farmer
                Details' | translate }}</p>
            <div class="p-fluid p-formgrid grid">
                <div class="field col-12 md:col-3">
                    <label for="appNo">{{'Tubewell App No (UHBVN/ DHBVN)' | translate}}</label>
                    <input id="appNo" type="text" pInputText formControlName="appNo">
                    <div *ngIf="ownMIfarmerDetailsForm.controls['appNo'].invalid && ownMIfarmerDetailsForm.controls['appNo'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['appNo'].errors.required">
                            {{'APPLICATION_NO_IS_REQUIRED' | translate}}</div>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label for="name">{{'FARMER_NAME' | translate}}</label>
                    <input id="name" type="text" pInputText formControlName="name">
                    <div *ngIf="ownMIfarmerDetailsForm.controls['name'].invalid && ownMIfarmerDetailsForm.controls['name'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['name'].errors.required">{{'FARMER_NAME_IS_REQUIRED'
                            | translate}}</div>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label for="fatherName">{{'FATHERS_NAME' | translate}}</label>
                    <input id="fatherName" type="text" pInputText formControlName="fatherName">
                    <div *ngIf="ownMIfarmerDetailsForm.controls['fatherName'].invalid && ownMIfarmerDetailsForm.controls['fatherName'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['fatherName'].errors.required">
                            {{'FATHERS_NAME_IS_REQUIRED' | translate}}</div>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label htmlFor="component">{{'Year of Installation'| translate}}</label>
                    <p-dropdown [options]="finYearList" appendTo="body" formControlName="finYear"
                        placeholder="{{'Select Fin Year'| translate}}" optionLabel="FinancialYears"
                        [showClear]="false"></p-dropdown>
                    <div *ngIf="ownMIfarmerDetailsForm.controls['finYear'].invalid && ownMIfarmerDetailsForm.controls['finYear'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['finYear'].errors.required">{{'Installation Year is
                            required' |
                            translate}}</div>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label htmlFor="selectProgram">{{'MIS Installed'| translate}}</label>
                    <div class="grid-item">
                        <p-dropdown [options]="componentMasterList" formControlName="programmeName"
                            optionLabel="Program_Name" (onChange)="onSelectProgramme()"
                            placeholder="{{'Select MIS Installed'| translate}}" appendTo="body">
                        </p-dropdown>
                    </div>
                    <div *ngIf="ownMIfarmerDetailsForm.controls['programmeName'].invalid && ownMIfarmerDetailsForm.controls['programmeName'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['programmeName'].errors.required">{{'MIS Installed
                            is required' |
                            translate}}</div>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label htmlFor="vendor">{{'VENDOR'| translate}} </label>
                    <div class="grid-item">
                        <!-- <p-autoComplete placeholder="{{ 'SEARCH_VENDOR' | translate }}" id="dd" [dropdown]="true" [multiple]="false" optionLabel="Name" optionValue="Vendor_Code"
                                formControlName="vendor" [suggestions]="filteredmiVendorList" (completeMethod)="filterMIVendor($event)" appendTo="body"
                                field="Name" (onSelect)="onVendorSelect($event)"></p-autoComplete> -->
                        <p-autoComplete placeholder="{{ 'SEARCH_VENDOR' | translate }}" id="dd" [dropdown]="true"
                            [multiple]="false" optionLabel="Name" optionValue="Vendor_Code" formControlName="vendor"
                            [suggestions]="filteredmiVendorList" (completeMethod)="filterMIVendor($event)"
                            appendTo="body" field="Name"></p-autoComplete>
                    </div>
                    <div *ngIf="ownMIfarmerDetailsForm.controls['vendor'].invalid && ownMIfarmerDetailsForm.controls['vendor'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['vendor'].errors.required">{{'VENDOR_IS_REQUIRED' |
                            translate}}</div>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label htmlFor="villageCode">{{'VILLAGE' | translate}}</label>
                    <p-autoComplete formControlName="villageCode" placeholder="{{'SEARCH_VILLAGE'| translate}}" id="dd"
                        [dropdown]="true" [multiple]="false" [suggestions]="filteredVillage"
                        (completeMethod)="filterVillage($event)" field="Name" value="Code"
                        [ngClass]="{ 'ng-invalid ng-dirty': ownMIfarmerDetailsForm.controls['villageCode'].touched  && ownMIfarmerDetailsForm.controls['villageCode'].errors }"></p-autoComplete>

                    <div *ngIf="ownMIfarmerDetailsForm.controls['villageCode'].invalid && ownMIfarmerDetailsForm.controls['villageCode'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['villageCode'].errors.required">
                            {{'VILLAGE_NAME_IS_REQUIRED' |
                            translate}}</div>
                    </div>
                </div>

                <!-- <div class="field col-12 md:col-4">
                    <label htmlFor="mfmbNo">{{'MFMB_NO' | translate}}</label>
                    <input maxlength="8" pattern="^[0-9]{8}$" pKeyFilter="int" formControlName="mfmbNo" pInputText
                        id="block" type="text"
                        [ngClass]="{ 'ng-invalid ng-dirty': personalDetailsForm.controls['mfmbNo'].invalid && personalDetailsForm.controls['mfmbNo'].touched }" />
                    <div *ngIf="personalDetailsForm.controls['mfmbNo'].invalid && personalDetailsForm.controls['mfmbNo'].touched"
                        class="invalid-feedback">
                        <div *ngIf="personalDetailsForm.controls['mfmbNo'].errors.required">{{'MFMB_NO_REQUIRED' |
                            translate}}</div>
                        <div *ngIf="personalDetailsForm.controls['mfmbNo'].errors.minlength">
                            {{'MFMB_NO_REQUIRED_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                            translate}}</div>
                        <div *ngIf="personalDetailsForm.controls['mfmbNo'].errors.maxlength">
                            {{'MFMB_NO_REQUIRED_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                            translate}}</div>
                    </div>
                </div> -->

                <div class="field col-12 md:col-3">
                    <label htmlFor="mobileNo">{{'MOBILE_NO' | translate}}</label>
                    <input class="readOnly" readonly maxlength="10" pattern="^[0-9]{10}$" pKeyFilter="int"
                        formControlName="mobileNo" pInputText id="mobileNo" type="text"
                        [ngClass]="{ 'ng-invalid ng-dirty': ownMIfarmerDetailsForm.controls['mobileNo'].invalid && ownMIfarmerDetailsForm.controls['mobileNo'].touched }" />

                    <div *ngIf="ownMIfarmerDetailsForm.controls['mobileNo'].invalid && ownMIfarmerDetailsForm.controls['mobileNo'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['mobileNo'].errors.required">
                            {{'MOBILE_NO_IS_REQUIRED'
                            | translate}}</div>

                        <div *ngIf="ownMIfarmerDetailsForm.controls['mobileNo'].errors.minlength">
                            {{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' |
                            translate}}</div>
                        <div *ngIf="ownMIfarmerDetailsForm.controls['mobileNo'].errors.maxlength">
                            {{'MOBILE_NO_SHOULD_BE_OF_10_DIGITS' |
                            translate}}</div>
                        <div *ngIf="ownMIfarmerDetailsForm.controls['mobileNo'].errors.pattern">
                            {{'MBILE_NO_SHOULD_CONTAIN'
                            | translate}}</div>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label htmlFor="block">{{'AADHAR_NUMBER' | translate}}</label>
                    <input maxlength="12" pattern="^[0-9]{12}$" pKeyFilter="int" formControlName="aadharNo" pInputText
                        id="block" type="text"
                        [ngClass]="{ 'ng-invalid ng-dirty': ownMIfarmerDetailsForm.controls['aadharNo'].invalid && ownMIfarmerDetailsForm.controls['aadharNo'].touched }" />

                    <div *ngIf="ownMIfarmerDetailsForm.controls['aadharNo'].invalid && ownMIfarmerDetailsForm.controls['aadharNo'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['aadharNo'].errors.required">
                            {{'AADHAR_NO_IS_REQUIRED'
                            | translate}}</div>
                        <div *ngIf="ownMIfarmerDetailsForm.controls['aadharNo'].errors.minlength">
                            {{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                            translate}}</div>
                        <div *ngIf="ownMIfarmerDetailsForm.controls['aadharNo'].errors.maxlength">
                            {{'AADHAR_NO_IS_SHOULD_BE_OF_12_DIGITS' |
                            translate}}</div>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label htmlFor="totalArea">{{'TOTAL_AREA_IN_ACRE' | translate}}</label>
                    <input pInputText inputId="killaNo" type="number" class="form-control" formControlName="totalArea"
                        [ngClass]="{ 'ng-invalid ng-dirty': ownMIfarmerDetailsForm.controls['totalArea'].invalid && ownMIfarmerDetailsForm.controls['totalArea'].touched }" />
                    <div *ngIf="ownMIfarmerDetailsForm.controls['totalArea'].invalid && ownMIfarmerDetailsForm.controls['totalArea'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['totalArea'].errors.required">
                            {{'TOTAL_AREA_IS_REQUIRED' |
                            translate}}</div>
                    </div>
                </div>

                <div class="field col-12 md:col-3">
                    <label htmlFor="killaNo">{{'Killa/ Morabba/ Khewat/ Khatoni No' | translate}}</label>
                    <input pInputText inputId="killaNo" type="text" class="form-control" formControlName="killaNo"
                        [pKeyFilter]="blockSpace"
                        [ngClass]="{ 'ng-invalid ng-dirty': ownMIfarmerDetailsForm.controls['killaNo'].invalid && ownMIfarmerDetailsForm.controls['killaNo'].touched }" />
                    <div *ngIf="ownMIfarmerDetailsForm.controls['killaNo'].invalid && ownMIfarmerDetailsForm.controls['killaNo'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['killaNo'].errors.required">{{'KILLA_NO_IS_REQUIRED'
                            |
                            translate}}</div>
                    </div>
                </div>

                <div class="field col-12 md:col-4">
                    <label for="name" class="ml-2">{{'Upload Bill' | translate}}</label>
                    <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerBillDocUpload
                        (uploadHandler)="onBillUpload($event, 'billPath', farmerBillDocUpload)" name="myfile[]"
                        [maxFileSize]="5000000" [multiple]="false" chooseLabel="{{'CHOOSE'| translate}}" [auto]="false"
                        [showCancelButton]="false">
                        <ng-template pTemplate="content">
                            <p-image *ngIf="ownMIfarmerDetailsForm.controls['billPath'].value"
                                [src]="ownMIfarmerDetailsForm.controls['billPath'].value" alt="Image" width="60"
                                class="ml-2" iconPos="left"></p-image>
                            <!-- <ul *ngIf="uploadedAadharFiles.length">
                            <li *ngFor="let file of uploadedAadharFiles">
                                <p-image *ngIf="ownMIfarmerDetailsForm.controls['aadharPhotoPath'].value"
                                    [src]="ownMIfarmerDetailsForm.controls['aadharPhotoPath'].value" alt="Image"
                                    width="60" class="ml-2" iconPos="left"></p-image>
                                {{ file.name }} - {{ file.size }} bytes
                            </li>
                        </ul> -->
                        </ng-template>
                    </p-fileUpload>
                    <div *ngIf="ownMIfarmerDetailsForm.controls['billPath'].invalid && ownMIfarmerDetailsForm.controls['billPath'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['billPath'].errors.required">
                            {{'BILL_IS_REQUIRED' | translate}}
                        </div>
                    </div>
                </div>

                <div class="field col-12 md:col-4">
                    <label for="name" class="ml-2">{{'Upload Land Ownership Paper' | translate}}</label>
                    <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #farmerlandOwnerDocUpload
                        (uploadHandler)="onLandOwnPaperUpload($event, 'landOwnerPath', farmerlandOwnerDocUpload)"
                        name="myfile[]" [maxFileSize]="5000000" [multiple]="false" chooseLabel="{{'CHOOSE'| translate}}"
                        [auto]="false" [showCancelButton]="false">
                        <ng-template pTemplate="content">
                            <p-image *ngIf="ownMIfarmerDetailsForm.controls['landOwnerPath'].value"
                                [src]="ownMIfarmerDetailsForm.controls['landOwnerPath'].value" alt="Image" width="60"
                                class="ml-2" iconPos="left"></p-image>
                            <!-- <ul *ngIf="uploadedAadharFiles.length">
                            <li *ngFor="let file of uploadedAadharFiles">
                                <p-image *ngIf="ownMIfarmerDetailsForm.controls['aadharPhotoPath'].value"
                                    [src]="ownMIfarmerDetailsForm.controls['aadharPhotoPath'].value" alt="Image"
                                    width="60" class="ml-2" iconPos="left"></p-image>
                                {{ file.name }} - {{ file.size }} bytes
                            </li>
                        </ul> -->
                        </ng-template>
                    </p-fileUpload>
                    <div *ngIf="ownMIfarmerDetailsForm.controls['landOwnerPath'].invalid && ownMIfarmerDetailsForm.controls['landOwnerPath'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['landOwnerPath'].errors.required">
                            {{'LAND_OWNERSHIP_PAPER_IS_REQUIRED' | translate}}
                        </div>
                    </div>
                </div>

                <!-- <div class="field col-12 md:col-4">
                    <label for="name" class="ml-2">{{'NOC certificate' | translate}}</label>
                    <p-fileUpload accept=".jpeg,.pdf,.jpg" [customUpload]="true" #nocCertificateUpload
                        (uploadHandler)="onLandOwnPaperUpload($event, 'nocCertificatePath', nocCertificateUpload)"
                        name="myfile[]" [maxFileSize]="5000000" [multiple]="false"
                        chooseLabel="{{'CHOOSE'| translate}}" [auto]="false" [showCancelButton]="false">
                        <ng-template pTemplate="content">
                            <p-image *ngIf="ownMIfarmerDetailsForm.controls['nocCertificatePath'].value"
                                [src]="ownMIfarmerDetailsForm.controls['nocCertificatePath'].value" alt="Image"
                                width="60" class="ml-2" iconPos="left"></p-image>
                            <ul *ngIf="uploadedAadharFiles.length">
                            <li *ngFor="let file of uploadedAadharFiles">
                                <p-image *ngIf="ownMIfarmerDetailsForm.controls['aadharPhotoPath'].value"
                                    [src]="ownMIfarmerDetailsForm.controls['aadharPhotoPath'].value" alt="Image"
                                    width="60" class="ml-2" iconPos="left"></p-image>
                                {{ file.name }} - {{ file.size }} bytes
                            </li>
                        </ul>
                        </ng-template>
                    </p-fileUpload>
                    <div *ngIf="ownMIfarmerDetailsForm.controls['nocCertificatePath'].invalid && ownMIfarmerDetailsForm.controls['landOwnerPath'].touched"
                        class="invalid-feedback">
                        <div *ngIf="ownMIfarmerDetailsForm.controls['nocCertificatePath'].errors.required">
                            {{'NOC Certificate is required' | translate}}
                        </div>
                    </div>
                </div> -->

                <div class="field col-12 md:col-4 button-container-submit">
                    <label></label>
                    <div class="grid-item mt-5">
                        <button pButton pRipple type="submit" label="{{'SUBMIT'| translate}}"
                            class="p-button-success mt-2 ml-5" style="width: 90px; height: 32px; align-items: center;">
                        </button>

                        <!-- <button pButton pRipple (click)="onSubmitForm()" label="{{'SUBMIT' | translate}}" class="p-button-success"
                                style="width: 100px; height: 32px; align-items: center;">
                            </button> -->
                    </div>
                </div>
            </div>
        </form>
    </div>

    <!-- <div class="button-container-submit">
        <button pButton pRipple (click)="onSubmitForm()" label="{{'SUBMIT' | translate}}" class="p-button-success"
            style="width: 100px; height: 32px; align-items: center;">
        </button>
    </div> -->
</div>